import { create } from 'zustand';

interface PopupOpenState {
    isDrawerOpen: boolean;
    setIsDrawerOpen: (open: boolean) => void;
}

// Create the Zustand store with types
const PopupOpenStateStore = create<PopupOpenState>((set) => ({
    isDrawerOpen: false,
    setIsDrawerOpen: (open: boolean) => set({ isDrawerOpen: open }),
}));

export default PopupOpenStateStore;
